import { useStore as useShapeStore } from '@/stores/v2/shape';
import { useStore as useProductStore } from '@/stores/v2/product';
import { useStore as useNotificationStore } from '@/stores/v2/notification';
import { useStore as useMirrorStore } from '@/stores/v2/mirror';
import cloneDeep from 'lodash.clonedeep';
import { StateSnapshot } from '@/typings/historyV2';

export function createStateSnapshot(): StateSnapshot {
  const shapeStore = useShapeStore();
  const productStore = useProductStore();
  const notificationStore = useNotificationStore();
  const mirrorStore = useMirrorStore();

  const snapshot: StateSnapshot = {
    shapeState: {
      shapes: cloneDeep(shapeStore.shapes),
      activeShapeId: shapeStore.activeShapeId,
      positionShapeMap: cloneDeep(shapeStore.positionShapeMap),
    },
    productState: {
      unavailablePrintPositions: cloneDeep(
        productStore.unavailablePrintPositions
      ),
      selectedPrintPosition: cloneDeep(productStore.selectedPrintPosition),
      lastManagedPrintPositionId: productStore.lastManagedPrintPositionId,
      previousManagedPrintPositionId:
        productStore.previousManagedPrintPositionId,
    },
    notificationState: {
      notifications: cloneDeep(notificationStore.notifications),
    },
    mirrorState: {
      mirrorShapes: cloneDeep(mirrorStore.mirrorShapes),
      positionMirrorShapeMap: cloneDeep(mirrorStore.positionMirrorShapeMap),
      positionMirrorSettings: cloneDeep(mirrorStore.positionMirrorSettings),
    },
  };

  return snapshot;
}
